import { useItem } from "@/api/items";

interface ItemCrumbProps {
  params: { id?: string };
}

/** Renders the item's name as a breadcrumb, reading from the React Query cache. */
export function ItemCrumb({ params }: ItemCrumbProps) {
  const itemQuery = useItem(params.id ? Number(params.id) : undefined);
  return <>{itemQuery.data?.name ?? "…"}</>;
}
